/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Patient API
 * API for Patient
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const GetPatientsInterviewResponseTypename = "GetPatientsInterviewResponse" as const;

/**
 *
 * @export
 * @interface GetPatientsInterviewResponse
 */
export interface GetPatientsInterviewResponse {
  /**
   *
   * @type {Date}
   * @memberof GetPatientsInterviewResponse
   */
  answeredTime?: string;
  /**
   *
   * @type {string}
   * @memberof GetPatientsInterviewResponse
   */
  interviewsType: GetPatientsInterviewResponseInterviewsTypeEnum;
  /**
   *
   * @type {Date}
   * @memberof GetPatientsInterviewResponse
   */
  lastConfirmedTime?: string;
  /**
   * Keys except key 'questionnaires' are for custom use only
   * @type {object}
   * @memberof GetPatientsInterviewResponse
   */
  questionnaires: object;
  /**
   *
   * @type {number}
   * @memberof GetPatientsInterviewResponse
   */
  version?: number;
  /**
   * Resource type name
   * @type {string}
   * @memberof GetPatientsInterviewResponse
   */
  readonly __typename?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum GetPatientsInterviewResponseInterviewsTypeEnum {
  Default = "default",
  Custom = "custom",
  Unused = "unused",
}

export function GetPatientsInterviewResponseFromJSON(json: any): GetPatientsInterviewResponse {
  return GetPatientsInterviewResponseFromJSONTyped(json, false);
}

export function GetPatientsInterviewResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetPatientsInterviewResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: GetPatientsInterviewResponseTypename,

    answeredTime:
      !exists(json, "answered_time") ||
      (typeof json["answered_time"] === "string" && json["answered_time"].substring(0, 4) === "0001")
        ? undefined
        : json["answered_time"],
    interviewsType: json["interviews_type"],
    lastConfirmedTime:
      !exists(json, "last_confirmed_time") ||
      (typeof json["last_confirmed_time"] === "string" && json["last_confirmed_time"].substring(0, 4) === "0001")
        ? undefined
        : json["last_confirmed_time"],
    questionnaires: json["questionnaires"],
    version: !exists(json, "version") ? undefined : json["version"],
  };
}

export function GetPatientsInterviewResponseToJSON(object?: GetPatientsInterviewResponse | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    answered_time: value.answeredTime === undefined ? undefined : tzDate(value.answeredTime).format(),
    interviews_type: value.interviewsType,
    last_confirmed_time: value.lastConfirmedTime === undefined ? undefined : tzDate(value.lastConfirmedTime).format(),
    questionnaires: value.questionnaires,
    version: value.version,
  };
}
